import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AngularFirestore } from '@angular/fire/firestore';
import { Chapter } from './../../models';
import { EcomicService } from './../../service/comics/ecomic.service';
import 'rxjs/add/operator/map';
import { AuthService } from './../../service/auth.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
declare const $: any;

@Component({
  selector: 'app-e-novel-chapter-add',
  templateUrl: './e-novel-chapter-add.component.html',
  styleUrls: ['./e-novel-chapter-add.component.css']
})
export class ENovelChapterAddComponent implements OnInit {
  imgurl1: any;
  imgurl2: any;
  novelchapterForm: FormGroup;
  loading: boolean = false;
  load: boolean = false;
  publish_date: any;
  series: any;
  seasons: any;
  id: any;
  user: any;
  reads: any;
  // variables to hide and show the dropdown to refresh the data to set the exact value
  status: any = true;
  showseason: any = false;
  showseries: any = false;
  chapterno: any = true;
  selectedseason: any;
  chaptererror: any = false;
  thumbnail_image: File;
  cover_image: File;
  thumbnail_image_url: any;
  cover_image_url: any;
  coverimageerror: any = false;
  thumbnailimageerror: any = false;
  singlechapter: any;
  constructor(private form: FormBuilder, private router: Router, private afs: AngularFirestore, private comicService: EcomicService,
    private route: ActivatedRoute, private auth: AuthService, public toastr: ToastsManager, vcr: ViewContainerRef) {
    this.toastr.setRootViewContainerRef(vcr);
  }

  ngOnInit() {
    // $(function () {
    //   // Datetimepicker plugin
    //   $('.datetimepicker').bootstrapMaterialDatePicker({
    //     format: 'dddd DD MMMM YYYY - HH:mm',
    //     clearButton: true,
    //     weekStart: 1
    //   });

    // });
    this.novelchapterForm = this.form.group({
      novel_series: ['', [Validators.required]],
      novel_seasons: ['', [Validators.required]],
      chapter_title: ['', [Validators.required]],
      chapter_no: ['chapter 1', [Validators.required]],
      chapter_description: ['', [Validators.required]],
      thumbnail: ['', []],
      novel_image: ['', []],
      hits: ['', [Validators.required]],
      seo_url: ['', [Validators.required]],
      seo_title: ['', [Validators.required]],
      seo_description: ['', [Validators.required]],
      seo_keywords: ['', [Validators.required]],
      status: ['InActive', [Validators.required]],
      publish_date_and_timer: ['', []],
    });
    try {
      // getting the available eseries from the database
      this.comicService.getnovelserious().then(eseriesdata => {
        // subscribing the data from the service
        eseriesdata.subscribe(eseries => {
          this.series = eseries;
          if (this.route.firstChild) {
            this.route.firstChild.params.subscribe(params => {
              this.id = params['id'];
              if (this.id) {
                this.status = false;
                this.showseries = false;
                this.showseason = false;
                this.chapterno = false;
                this.comicService.getsinglenovel(this.id, 'Enovelchapter').then(chapterdata => {
                  chapterdata.subscribe(singlechapter => {
                    console.log(singlechapter);
                    this.singlechapter = singlechapter;
                    this.comicService.getnovelseasons(singlechapter['novel_series']).then(eseasonsdata => {
                      // subscribing the data from the service
                      eseasonsdata.subscribe(eseasons => {
                        this.seasons = eseasons;
                        this.novelchapterForm.get('novel_series').setValue(singlechapter['novel_series']);
                        this.novelchapterForm.get('novel_seasons').setValue(singlechapter['novel_seasons']);
                        this.novelchapterForm.get('chapter_title').setValue(singlechapter['chapter_title']);
                        this.novelchapterForm.get('chapter_no').setValue(singlechapter['chapter_no']);
                        this.novelchapterForm.get('chapter_description').setValue(singlechapter['chapter_description']);
                        this.novelchapterForm.get('thumbnail').setValue(singlechapter['thumbnail']);
                        this.novelchapterForm.get('novel_image').setValue(singlechapter['novel_image']);
                        this.novelchapterForm.get('hits').setValue(singlechapter['hits']);
                        this.novelchapterForm.get('seo_url').setValue(singlechapter['seo_url']);
                        this.novelchapterForm.get('seo_title').setValue(singlechapter['seo_title']);
                        this.novelchapterForm.get('seo_description').setValue(singlechapter['seo_description']);
                        this.novelchapterForm.get('seo_keywords').setValue(singlechapter['seo_keywords']);
                        this.novelchapterForm.get('status').setValue(singlechapter['status']);
                        const date = singlechapter['publish_date_and_timer']?new Date(singlechapter['publish_date_and_timer'].seconds*1000):''
                        // const publishdate = `${date.getMonth()}/${date.getDate()}/${date.getFullYear()} ${date.getHours()}:${date.getMinutes()}`;
                        this.novelchapterForm.get('publish_date_and_timer').setValue(date);
                        this.cover_image_url = singlechapter['cover_image'];
                        this.thumbnail_image_url = singlechapter['thumbnail_image'];
                        this.status = true;
                        this.showseries = true;
                        this.showseason = true;
                        this.chapterno = true;
                      });
                    });
                  });
                });
              }
            });
          } else {

            console.log(this.showseries);
            this.getnovelseasons(this.series[0].id);
            this.novelchapterForm.get('novel_series').setValue(this.series[0].id);
            console.log('asdfdfs')
            this.showseries = true;
            if (!this.id) {
              this.auth.getuser().then(userdetails => {
                this.user = userdetails;
              });
            }
          }
        });
      });

    } catch (error) {
      console.log(error);
    }
  }

  async addchapter(value, valid) {

    if (valid) {
      await this.comicService.checkchapter(value.novel_seasons, value.chapter_no).then(async chapter => {
        if (chapter) {
          if (!this.id) {
            this.toastr.error('The chapter is already added!', 'Oops!');
            return true
          } else if (value.chapter_no != this.singlechapter.chapter_no) {
            this.toastr.error('The chapter is already added!', 'Oops!');
            return true
          }
        }
        this.loading = true;
        const season: Chapter = {
          novel_series: value.novel_series,
          novel_seasons: value.novel_seasons,
          chapter_title: value.chapter_title,
          chapter_description: value.chapter_description,
          chapter_no: value.chapter_no,
          chapter_number: parseInt(value.chapter_no.slice(8)),
          hits: value.hits,
          seo_url: value.seo_url,
          seo_title: value.seo_title,
          seo_description: value.seo_description,
          seo_keywords: value.seo_keywords,
          status: value.status,
          publish_date_and_timer: value.publish_date_and_timer?new Date(value.publish_date_and_timer):'',
        };
        try {
          if (this.id) {
            let thumbnail;
            let coverimage;
            // Checking if the cover image is changed if changed the update the image in sapces and also db.
            if (this.cover_image) {
              coverimage = await this.auth.uploadimage('novel/cover/', this.cover_image, false);
              season.cover_image = coverimage['Location'];
            }
            // Checking if the thumbnail image is changed if changed the update the image in sapces and also db.
            if (this.thumbnail_image) {
              thumbnail = await this.auth.uploadimage('novel/thumbnail/', this.thumbnail_image, false);
              season.thumbnail_image = thumbnail['Location'];
            }
            const document = await this.afs.doc(`/Enovelchapter/${this.id}`);
            const update = await document.update(season);
            this.toastr.success('Enovel chapter Added!', 'Success!');
            this.router.navigate(['/novel-chapter']);
          } else {
            if (!this.thumbnail_image) { this.thumbnailimageerror = true; this.loading = false; return false; }
            if (!this.cover_image) { this.coverimageerror = true; this.loading = false; return false; }
            // uploading the images to the spaces and getting the uoloaded location
            const thumbnail = await this.auth.uploadimage('novel/thumbnail/', this.thumbnail_image, false);
            const coverimage = await this.auth.uploadimage('novel/cover/', this.cover_image, false);
            const updatereads = await this.afs.doc('Enovelseason/' + value.novel_seasons).update({ reads: this.reads + parseInt(value.hits) })
            season.thumbnail_image = thumbnail['Location'];
            season.cover_image = coverimage['Location'];
            season.admin = this.user.uid;
            season.addedby = this.user.username;
            season.createdAt = new Date();
            season.date = new Date().toString();
            season.season_title = this.selectedseason.season_title;
            console.log(season)
            const eseasondata = await this.afs.collection('Enovelchapter').add(season);
            const esid = eseasondata.id;
            const id = await this.afs.doc(`/Enovelchapter/${esid}`).update({ id: esid });
            this.toastr.success('Enovel chapter Added!', 'Success!');
            this.router.navigate(['/novel-chapter']);
          }
        } catch (error) {
          this.loading = false;
          this.load = true;
        }
      })
    } else {
      console.log('error');
    }
  }
  async setseason(id) {
    const singleseason = await this.afs.doc('/Enovelseason/' + id);
    const data = singleseason.valueChanges();
    data.subscribe(season => {
      this.selectedseason = season;
      this.reads = parseInt(season['reads']);
    });
    return true;
  }

  async getnovelseasons(id) {
    this.showseason = false;
    try {
      await this.comicService.getnovelseasons(id).then(eseasonsdata => {
        // subscribing the data from the service
        eseasonsdata.subscribe(eseasons => {
          this.seasons = eseasons;
          console.log(this.seasons);
          if (this.seasons.length >= 1) {
            this.novelchapterForm.get('novel_seasons').setValue(eseasons[0]['id']);
            this.setseason(eseasons[0]['id']);
          }
          console.log('sadfa');

          this.showseason = true;
        });
      });
    } catch (error) {
      this.showseason = true;
      console.log(error);
    }
  }


  changeListner1(event) {
    this.thumbnailimageerror = false;
    if (event.target.files && event.target.files[0]) {
      this.thumbnail_image = event.target.files[0];
      var reader = new FileReader();

      reader.onload = (event: any) => {
        this.thumbnail_image_url = event.target.result;
      }

      reader.readAsDataURL(event.target.files[0]);
    }
  }

  changeListner2(event) {
    this.coverimageerror = false;
    if (event.target.files && event.target.files[0]) {
      this.cover_image = event.target.files[0];
      var reader = new FileReader();

      reader.onload = (event: any) => {
        this.cover_image_url = event.target.result;
      }

      reader.readAsDataURL(event.target.files[0]);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/E-novels/e-novel-chapter-add/e-novel-chapter-add.component.ts